
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-77516b36\",\"scoped\":true,\"hasInlineConfig\":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./center.vue")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader?{\"cacheDirectory\":true,\"presets\":[[\"env\",{\"modules\":false,\"targets\":{\"browsers\":[\"> 2%\"],\"uglify\":true}}]]}!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./center.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-77516b36\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./center.vue"),
  /* scopeId */
  "data-v-77516b36",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./resources/js/components/player/page/center.vue
// module id = 97
// module chunks = 0